import React from "react";

function IconTextMessage() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 4.75a5.25 5.25 0 110 10.5H7c-.16 0-.318-.007-.473-.021a.75.75 0 00-.304.036l-3.037 1.011.523-1.57a.75.75 0 00-.211-.795A5.25 5.25 0 017 4.75h6zM19.75 10A6.75 6.75 0 0013 3.25H7a6.75 6.75 0 00-4.864 11.43l-.848 2.544a.75.75 0 00.949.95l4.316-1.439c.148.01.297.015.447.015h6A6.75 6.75 0 0019.75 10z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 11a1 1 0 100-2 1 1 0 000 2zm4 0a1 1 0 100-2 1 1 0 000 2zm5-1a1 1 0 11-2 0 1 1 0 012 0z"
      />
    </svg>
  );
}

export default IconTextMessage;
